import { render, staticRenderFns } from "./QuizLayout.vue?vue&type=template&id=6d0bb7f2&scoped=true&"
import script from "./QuizLayout.vue?vue&type=script&lang=js&"
export * from "./QuizLayout.vue?vue&type=script&lang=js&"
import style0 from "./QuizLayout.vue?vue&type=style&index=0&id=6d0bb7f2&lang=scss&scoped=true&"
import style1 from "./QuizLayout.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d0bb7f2",
  null
  
)

export default component.exports